import * as React from "react";

function AheadBehindIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19 19" fill="none" {...props}>
      <path
        stroke="#fff"
        d="M.5.503L7.5.5l.008 17.004-7 .003zM10.5.503l7-.003.008 17.004-7 .003z"
      />
      <path fill="#fff" d="M0 10h8l.008 8.006-8 .002zM9.995 5h8l.014 13h-8z" />
    </svg>
  );
}

const MemoAheadBehindIcon = React.memo(AheadBehindIcon);
export default MemoAheadBehindIcon;
